<template>
    <div class="custom-spinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
    </div>
</template>

<script>
    import "./CustomSpinner.scss";

    export default {
        name: "CustomSpinner"
    };
</script>
